const styles: Record<string, string> = {
  childrens_goods: 'bottom-[50%] w-[12.53vh] max-w-[116px] aspect-[232/456]',
  electronics: 'bottom-[60%] w-[19.11vh] max-w-[177px] aspect-[177/220]',
  furniture_factory: 'bottom-[87.5%] w-[28.62vh] max-w-[265px] aspect-square',
  garment_factory: 'bottom-[45%] w-[14.31vh] max-w-[135.5px] aspect-[1/2]',
  homeware: 'bottom-[70%] w-[17.17vh] max-w-[159px] aspect-[308/440]',
  machinery: 'bottom-[80%] w-[21.6vh] max-w-[200px] aspect-square',
  musical_equipment: 'bottom-[70%] w-[17.17vh] max-w-[159px] aspect-[308/464]',
  printing_factory: 'bottom-[75%] w-[21.81vh] max-w-[202px] aspect-[202/220]',
  toolmaking: 'bottom-[75%] w-[20.73vh] max-w-[192px] aspect-[384/438]',
};

export { styles };
